import src from "IMAGE";
export default { src, width: 935, height: 189, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAGklEQVR42oXKIQEAAAACIKr/D/tAAw3IsUMBEfoAkQNVp6UAAAAASUVORK5CYII="};
